import { useContainer } from "@contexts/container-context";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const useOrganizationTags = (
  organizationCode,
  tagType,
  options = {}
) => {
  const { organizationService } = useContainer();

  return useQuery({
    queryKey: ["organizationTags", organizationCode, tagType],
    queryFn: () =>
      organizationService.getOrganizationTags(organizationCode, tagType),
    enabled: !!(organizationCode && tagType),
    ...options,
  });
};

export const useCreateOrganizationTag = (organizationCode, options = {}) => {
  const { organizationService } = useContainer();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (tag) =>
      organizationService.createOrganizationTag(organizationCode, tag),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["organizationTags", organizationCode],
      });
    },
    ...options,
  });
};

export const useDeleteOrganizationTag = (organizationCode, options = {}) => {
  const { organizationService } = useContainer();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (tagId) =>
      organizationService.deleteOrganizationTag(organizationCode, tagId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["organizationTags", organizationCode],
      });
      queryClient.invalidateQueries({
        queryKey: ["organizationDevices", organizationCode],
      });
    },
    ...options,
  });
};

export const useUpdateOrganizationTag = (organizationCode, options = {}) => {
  const { organizationService } = useContainer();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (tag) =>
      organizationService.updateOrganizationTag(organizationCode, tag),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["organizationTags", organizationCode],
      });
      queryClient.invalidateQueries({
        queryKey: ["organizationDevices", organizationCode],
      });
    },
    ...options,
  });
};

export const useSetDeviceTags = (organizationCode, options = {}) => {
  const { organizationService } = useContainer();

  return useMutation({
    mutationFn: ({ deviceId, tagIds }) =>
      organizationService.setDeviceTags(organizationCode, deviceId, tagIds),
    ...options,
  });
};
